import script from "./MainFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MainFooter.vue?vue&type=script&setup=true&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=f8fc4ec4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8fc4ec4"]])

export default __exports__